import React from 'react';
import toast from 'react-hot-toast';
import {IconButton} from '@material-ui/core';
import RonadIcons from '../components/iconComponent';

export default (
  text: string | string[],
  type: 'success' | 'info' | 'error' | 'warn' | 'm-success' | 'm-error'
) => {
  switch (type) {
    case 'm-success':
      toast.success(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <p>
            {text.map(el => {
              return (
                <>
                  <span>{el}</span>
                  <br />
                </>
              );
            })}
          </p>
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <RonadIcons name="times" size={0.8} className="text-white"/>
          </IconButton>
        </div>
      ));
      break;
    case 'm-error':
      toast.error(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <RonadIcons name="times" size={0.8} className="text-white"/>
          </IconButton>
        </div>
      ));
      break;
    case 'success':
      toast.success(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
          id='success-toast'
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <RonadIcons name="times" size={0.8} className="text-white"/>
          </IconButton>
        </div>
      ));
      break;
    case 'error':
      toast.error(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <RonadIcons name="times" size={0.8} className="text-white"/>
          </IconButton>
        </div>
      ));
      break;
    case 'warn':
      toast(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <RonadIcons name="times" size={0.8} className="text-white"/>
          </IconButton>
        </div>
      ));
      break;
    case 'info':
      toast(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <RonadIcons name="times" size={0.8} className="text-white"/>
          </IconButton>
        </div>
      ));
      break;
    default:
      toast(text, {
        position: 'top-right',
        duration: 5000,
      });
      break;
  }
};
